<form id="tax-form" [formGroup]="taxForms" (ngSubmit)="save()">
  <h4>Do you want CurbNTurf to collect taxes for you?</h4>
  <p>
    If you choose to have CurbNTurf collect taxes for you, then you will specify all taxes to collect, and CurbNTurf
    will add those taxes to the total cost and then include them in the payout along with a record of how much you
    received for each tax so you can then remit your taxes. You will still be responsible for paying the tax.
  </p>
  <div class="tax-wrapper">
    <label class="w-checkbox checkbox-field grid">
      <div
        class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"
        [ngClass]="{ 'w--redirected-checked': collectTaxes?.value === true }"
      ></div>
      <input
        type="radio"
        id="collect-taxes-yes"
        [formControl]="collectTaxes"
        [value]="true"
        (click)="ensureOneTax()"
        style="opacity: 0; position: absolute; z-index: -1"
      />
      <span for="Checkbox" class="checkbox-label w-form-label"> Yes </span>
    </label>
    <label class="w-checkbox checkbox-field tax">
      <div
        class="w-checkbox-input w-checkbox-input--inputType-custom checkbox"
        [ngClass]="{ 'w--redirected-checked': collectTaxes?.value === false }"
      ></div>
      <input
        type="radio"
        id="collect-taxes-no"
        [formControl]="collectTaxes"
        [value]="false"
        style="opacity: 0; position: absolute; z-index: -1"
      />
      <span for="Checkbox-6" class="checkbox-label w-form-label"> No, I&rsquo;m collecting on my own. </span>
    </label>
  </div>
  <ng-container *ngFor="let taxes of taxControls.controls; let i = index">
    <div class="divider-line"></div>
    <div class="tax-information-grid">
      <div>
        <div class="title">
          <strong> Tax Rate </strong>
        </div>
        <div class="input-w-label tax">
          <input
            type="number"
            [formControl]="taxes.controls.rate"
            step="1"
            min="0"
            max="100"
            id="tax-rate-{{ i }}"
            class="text-field-rounded-left w-input"
          />
          <div class="element-inner">
            <div class="element-bold">%</div>
          </div>
        </div>
      </div>
      <div class="tax-inner">
        <div class="title">
          <strong> Tax Identification </strong>
        </div>
        <input
          type="text"
          [formControl]="taxes?.controls.name"
          title="The name of the tax. It will be shown to the guest. An example might be 'Idaho Sales tax'."
          placeholder="Name your tax"
          id="tax-name-{{ i }}"
          class="text-input text-input-rounded w-input"
        />
      </div>
      <div>
        <div class="title">
          <strong> What properties do you want to apply this tax </strong>

          <div (click)="removeTaxForm(taxes.value)" class="icon-trash-wrapper">
            <div class="html-embed w-embed">
              <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="site-tax-options">
      <div *ngFor="let listing of listings">
        <div class="rift-soft-title" [innerHTML]="listing.getName()"></div>
        <curbnturf-toggle
          [selected]="listingHaveTaxes(listing, taxes.value)"
          (clicked)="toggleListingTaxes(listing, taxes.value)"
        >
        </curbnturf-toggle>
      </div>
    </div>
  </ng-container>
  <div class="bottom-button-wrapper listing">
    <a *ngIf="collectTaxes.value" (click)="addTaxForm()" class="cnt-button filter w-inline-block">
      <div class="cnt-button-copy">Add another tax profile</div>
    </a>
  </div>
</form>
